import menuInit from './menu';
import navbarInit from './navbar';

window.onload = async () => {
  if (document.getElementsByClassName('slider').length) {
    import('./slider').then((module) => module.default());
  }
  if (document.getElementsByClassName('banner-split').length) {
    import('./banner').then((module) => module.default());
  }
  if (document.querySelectorAll('.card--team').length) {
    import('./team').then((module) => module.default());
  }
  if (document.querySelectorAll('.post-slider').length) {
    import('./postslider').then((module) => module.default());
  }
  if (document.querySelectorAll('.quote-slider').length) {
    import('./quoteslider').then((module) => module.default());
  }
  if (document.querySelectorAll('.module-slider').length) {
    import('./moduleslider').then((module) => module.default());
  }
  if (document.querySelectorAll('.video-background').length) {
    import('./videobackground').then((module) => module.default());
  }
  if (document.querySelectorAll('.slider__intro').length) {
    import('./paginationFix').then((module) => module.default());
  }
};

document.addEventListener('DOMContentLoaded', () => {
  import(/* webpackPrefetch: true */ './icons');
  menuInit();
  navbarInit();
});
